import React, { useState } from 'react';

import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import makeStyles from '@material-ui/core/styles/makeStyles';

import logo from './logo.png';
import UploadList from './UploadList';
import UploadDialog from './UploadDialog';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    flexDirection: 'row',
    padding: '1em'
  }
});

export default function Upload() {
  const classes = useStyles();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <main className={classes.row}>
        <UploadList />
        <Fab color="primary" onClick={() => setDialogOpen(true)}>
          <AddIcon />
        </Fab>
        <UploadDialog open={dialogOpen} setOpen={setDialogOpen} />
      </main>
    </div>
  );
}